<script setup lang="ts">
import type { ContentItem } from "@edco/apollo";
import type { DynamicContentItem } from "~/models/generated/DynamicContentItem";
import type { ArticleArea } from "~/models/generated/ArticleArea";
import { useMigratedSeo } from "~/composables/useMigratedSeo";

const props = defineProps<{
  content: ContentItem<DynamicContentItem>;
}>();

const auditResource = $auditResource();
const route = useRoute();
const auth = useAuth();

useMigratedSeo( () => props.content );

onMounted( async () => {
  auditResource.logPageView( props.content.id );
  // Refresh auth data to get current subscriber status
  if ( auth.isLoggedIn.value ) {
    await auth.refresh();
  }
} );

const articleArea = ref<ContentItem<ArticleArea>>();
const contentResource = useContentDeliveryResource();
if ( route.path.includes( "express-interest" ) ) {
  const { data } = await contentResource.getByTypeSingle<ArticleArea>( "articleArea" );
  articleArea.value = data.value ?? undefined;
}
</script>

<template>
  <main class="content-page">
    <DynamicBanner
      v-if="content.properties.enableBanner"
      :content="content" />

    <block-list :content="content.properties.grid" />

    <div class="container">
      <RegisterInterestForm
        v-if="articleArea"
        :article-area="articleArea" />
    </div>
  </main>
</template>

<style lang="scss" scoped>
.content-page {
  min-height: 60vh;
  padding-bottom: 60px;
  margin-top: -20px;

  &__main {
    max-width: 900px;
    margin: 0 auto;
  }

  &__heading {
    text-align: center;
  }
}
.subscribe-panel {
  background-color: rgba(98, 187, 173, 0.1);
  border-radius: 12px;
  padding: 40px;
}
.subscribe-btns {
  .btn {padding:10px 20px;border-radius: 40px;border: 1px solid #62BBAD;background: #fff;margin-right: 40px;
  @media ( max-width: 991px ) {
    margin-bottom: 20px;
    width: 100%;
  }
  }
}
</style>
